const myInfo = {
    firstName: 'Aena',
    lastName: 'Teodocio',
    phoneNumber: '1-204-218-7715',
    email: 'teodocio.am@gmail.com',
    linkedIn: 'https://www.linkedin.com/in/aenateodocio/',
    gitHub: 'https://github.com/ela-codes'
  };
  
  export default myInfo;